// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2chFg","type":"styles_type__3lD56","choices":"styles_choices__H8-k6"};